// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34Kmn","col":"styles_col__2D0PJ"};